import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { ThemeSelector } from "@/shared/ui";

export default function ThemeSettings() {
  const { t } = useTranslation();

  return (
    // No outer padding — DashboardLayout's content wrapper already supplies the
    // page shell. See Profile.tsx.
    <div>
      <Helmet>
        <title>{t("settings.theme.pageTitle")} {t("settings.theme.storemandu")}</title>
        <meta name="description" content={t("settings.theme.pageTitle")} />
      </Helmet>

      {/* ── Page header ── */}
      <div className="mb-6 sm:mb-8 flex items-start gap-3 sm:gap-4">
        <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-xl flex items-center justify-center flex-shrink-0 mt-0.5 transition-colors duration-300 bg-primary-soft">
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="text-brand"
            stroke="currentColor"
          >
            <circle cx="12" cy="12" r="10"/>
            <path d="M12 2a10 10 0 0 1 10 10"/>
            <path d="M12 6v6l4 2"/>
            <circle cx="12" cy="12" r="3"/>
          </svg>
        </div>
        <div className="min-w-0 flex-1">
          <h1 className="text-page-title">
            {t("settings.theme.appearance")}</h1>
          <p className="text-xs sm:text-sm text-tertiary mt-1 leading-relaxed">
            {t("settings.theme.customizeHowThe")}</p>
        </div>
      </div>

      {/* ── Body ── */}
      <div className="max-w-lg">
        <div className="bg-surface-elevated border rounded-xl p-4 sm:p-6 shadow-sm">
          <ThemeSelector />
        </div>
      </div>
    </div>
  );
}
